import React from 'react';

import Button from 'components/shared/Button';
import { useModalClose } from 'hooks/useModalClose';

import ModalWrapper from '../index';
import cs from '../index.module.css';

const ChangesDetectedModal = ({ onClose }: { onClose: () => void }) => {
  useModalClose();

  const handlePageReload = () => {
    window.location.reload();
  };

  return (
    <ModalWrapper
      onClose={onClose}
      header="Changes Detected"
      body={
        <div className={cs.description}>
          Changes have been applied to this itinerary by another user. Do you want to refresh the page to see the latest
          updates or keep editing your current version?
          <br />
          <br />
          <strong>Note: if you refresh the page, you will lose any unsaved changes.</strong>
        </div>
      }
      footer={
        <>
          <Button type="default" size="medium" onClick={handlePageReload}>
            Refresh Page
          </Button>
          <Button size="medium" onClick={onClose}>
            Keep Editing
          </Button>
        </>
      }
    />
  );
};

export default ChangesDetectedModal;
